<template>
    <div class="product__block">
        <div class="product__block__l" @click="productId(id)">
            <div v-if="remain <= 0" class="remain_null">
                <p>
                    Нет в продаже
                </p>
            </div>
            <div class="product__block__img">
                <img :src="'https://ecodom04.com/backend/'+img" alt="images">
            </div>
            <div class="product__block___btn__and__price">
                <div class="product__block__title">
                    <p>
                        {{title}}  
                    </p>
                </div>
                <div class="product__block___btn__and__price__l">
                    <p>
                        <span>{{price | numeral('0,0')}}</span> ₸
                    </p>
                </div>
            </div>
        </div>
        <div class="product__block___btn__and__price__r">
            <button v-if="remain <= 0" class="remain_btn"  @click="addToCart" title="Оформить предзаказ">
                <span class="mdi mdi-basket"></span>
                Оформить предзаказ
            </button>
            <button v-if="remain > 0"  @click="addToCart" title="Добавить в корзину">
                <span class="mdi mdi-basket"></span>
                Добавить в корзину
            </button>
            <button class="favorite__add" @click="addToFavorite" title="Добавить в избранное">
                <span class="mdi mdi-cards-heart"></span>
                Добавить в избранное
            </button>
        </div>
    </div>
</template>


<script>
import {mapActions} from 'vuex'

export default {
  name: 'CategoryProduct',
  props: ['id', 'img', 'title', 'price', 'description', 'remain'],
  methods: {
    productId(id) {
        this.$router.push({ name: 'ProductPage', params: { id: id }})
    },
    ...mapActions([
          'ADD_TO_CART',
          'ADD_TO_FAVORITE'
    ]),
    addToCart(){
        this.ADD_TO_CART({
            id: this.id,
            img: this.img,
            title: this.title,
            price: this.price,
            quantity: 1,
            oldprice: this.price,
            description: this.description,
            remain: this.remain,
        })
        this.$toasted.show('Добавлен в корзину').goAway(1500)
    },
    addToFavorite() {
        this.ADD_TO_FAVORITE({
            id: this.id,
            img: this.img,
            title: this.title,
            price: this.price,
            description: this.description,
            remain: this.remain,
        })
        this.$toasted.show('Добавлен в избранное').goAway(1500)
    }
  }
}
</script>

<style scoped lang="less">
@baseMedia: 900px;
.product__block {
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
    border: 1px solid #ccc;
    border-radius: 5px;
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 10px;
    &:hover {
        box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
    }
    @media (max-width: @baseMedia) {
       justify-content: center;
       flex-wrap: wrap;
    }
    .product__block__l {
        width: 80%;
        display: flex;
        align-items: flex-start;
        flex-direction: row;
        position: relative;
        @media (max-width: @baseMedia) {
            width: 100%;
            justify-content: center;
            flex-wrap: wrap;
        }
        .remain_null {
            padding: 5px 10px;
            color: #fff;
            font-weight: bold;
            background: red;
            position: absolute;
            top: 0;
            box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.75);
            left: 0;
        }
        &:hover {
            .product__block___btn__and__price {
                .product__block__title {
                    p  {
                        text-decoration: underline;
                    }
                }
            }
        }
        .product__block__img {
            width: 32%;
            height: 150px;
            margin-left: 1%;
            background: #fff;
            border: 1px solid #ccc;
            text-align: center;
            border-radius: 5px;
            overflow: hidden;
            @media (max-width: @baseMedia) {
                width: 95%;
                margin-left: 0px;
                margin: 0 auto;
            }
            img {
                height: 95%;
                margin-top: 5px;
                &:hover {
                    transition: 2s;
                    height: 110%;
                }
            }
        }
        
        .product__block___btn__and__price {
            width: 60%;
            margin-left: 1%;
            margin-right: 1%;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            @media (max-width: @baseMedia) {
                width: 95%;
                margin-left: 0px;
                margin-right: 0px;
                margin: 0 auto;
            }
            .product__block__title {
                width: 100%;
                text-align: left;
                margin-bottom: 15px;
                font-weight: bold;
                font-size: 21px;
                @media (max-width: @baseMedia) {
                    margin: 0 auto;
                    font-size: 17px;
                }
            }
            .product__block___btn__and__price__l {
                width: 100%;
                text-align: left;
                p {
                    font-size: 24px;
                    color: #690;
                    @media (max-width: @baseMedia) {
                        font-size: 17px;
                    }
                    span {
                        font-weight: bold;
                    }
                }
            }
        }
    }
    
    .product__block___btn__and__price__r {
        width: 25%;
        @media (max-width: @baseMedia) {
            width: 95%;
            margin: 0 auto;
            margin-top: 10px;
        }
        .remain_btn {
            background: #eefd00;
            font-weight: bold;
            color: #000;
            @media (max-width: @baseMedia) {
                font-size: 14px;
            }
            span {
                    color: #000;
            }
        }
        .favorite__add {
            background: #942737;
            margin-top: 10px;
            @media (max-width: @baseMedia) {
                font-size: 14px;
                margin-top: 5px;
            }
        }
        button {
            width: 96%;
            background: #0a9;
            padding: 10px;
            border-radius: 5px;
            color: #fff;
            @media (max-width: @baseMedia) {
                font-size: 14px;
                margin-top: 5px;
            }
            span {
                color: #fff;
            }
            &:hover {
                opacity: 0.7;
            }
        }
    }
}
 
</style>
